"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var PPIconLink_1 = require("../PPIconLink");
var PPTooltip_1 = __importDefault(require("../PPTooltip"));
require("../../assets/PPModal.css");
var PPModal = function (props) {
    var calcWidth = function () {
        if (!props.size)
            return "600px";
        switch (props.size) {
            case "small":
                return "300px";
            case "medium":
                return "600px";
            case "large":
                return "1200px";
            default:
                return props.size;
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, props.visible &&
        react_1.default.createElement("div", { className: 'pp-modal', onClick: function () { !props.title && props.onClose(false); } },
            react_1.default.createElement("div", { className: "body", style: { width: calcWidth() } },
                props.title &&
                    react_1.default.createElement("div", { className: "header" },
                        react_1.default.createElement("div", { className: "title" }, props.title),
                        react_1.default.createElement(PPIconLink_1.PPIconLink, { icon: 'ppi ppi-x', onClick: function () { props.onClose(false); } })),
                react_1.default.createElement("div", { className: "content" }, props.loading ?
                    react_1.default.createElement("div", { className: 'loading' },
                        react_1.default.createElement("i", { className: "ppi ppi-loading ppi-spin ppi-7x text-link" }))
                    :
                        props.children),
                props.functions &&
                    react_1.default.createElement("div", { className: "functions" }, props.functions.map(function (f, i) {
                        return (react_1.default.createElement(PPTooltip_1.default, { key: i, content: f.tooltip, trigger: 'hover' },
                            react_1.default.createElement("button", { id: "ppmodal_button_".concat(f.label), className: "pp-button bg-".concat(f.context || "info").concat(f.hidden ? " hide" : "").concat(f.disabled ? " disabled" : ""), type: "button", onClick: function () { !f.disabled && f.onClick(); } }, f.label)));
                    }))))));
};
exports.default = PPModal;
